import Choices from "choices.js";

class ChoicesSelect
{
	constructor(el: HTMLSelectElement)
	{
		new Choices(el, {
			searchEnabled: false,
			itemSelectText: '',
			shouldSort: false
		});
	}
}

document.querySelectorAll<HTMLSelectElement>(".select-choices").forEach(el =>
{
	new ChoicesSelect(el);
});